import React, {useState, useEffect} from 'react'
import CustomAppBar from '../components/CustomAppBar'
import { Typography, Grid, Box, Skeleton} from '@mui/material'
import { useNavigate } from 'react-router-dom';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import GroupContainer from '../components/GroupContainer';
import PrimaryButton from '../components/PrimaryButton';
import PlusButton from '../components/PlusButton';
// api
import { initializeUserAndData } from '../api/apiFetcher';
import { fetchAndDispatchGroupHearts } from '../api/apiFetcher';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { setLoading, updateUser } from '../redux/userSlice';

// utils
import { getGroupIDFromTopic } from '../validation/utils';
// mqtt
import { cleanupClient, subscribeToTopics } from '../api/mqtt';
import { MQTT_TOPIC_PREFIX } from '../constants';
import HeartContainer from '../components/HeartContainer';
import { createColorListener } from '../api/mqtt-handlers';

function Home() {
  // state variables for groups and hearts from store
  const hearts = useSelector((state) => state.heart.hearts);
  const groups = useSelector((state) => state.group.groups);
  const user = useSelector((state) => state.user.user);
  const groupHearts = useSelector((state) => state.heart.groupHearts);
  const doneTitle = useSelector((state) => state.done);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);   // loading is redux variable for use across pages
  const isUserLoaded = useSelector((state) => state.user.isUserLoaded);
  const subscribedTopics = useSelector((state) => state.mqtt.subscribedTopics); // avoid resubscribing to topics

  // useEffect hook to subscribe to color topics for all groups
  useEffect(() => {

    let cleanup;
    if (isUserLoaded && subscribedTopics.length === 0) {
      // Subscribe to color topics for all groupss
      const topics = []
      groups.forEach((group) => topics.push(`${MQTT_TOPIC_PREFIX}${group.id}/color`));
      const listener = createColorListener(groups, dispatch);

      cleanup = subscribeToTopics(topics, dispatch, listener, subscribedTopics);
    }
    else {
      console.log("User not loaded yet or already subscribed, skipping MQTT subscription.");
    }
    dispatch(setLoading(false));
    return cleanup;
  }, [isUserLoaded]); // Note: only re-run the effect if isUserLoaded changes

  return (
    <AppContainer>
      <CustomAppBar />
      <TextContainer>
        <Box sx={{display: 'flex', flexDirection: 'row', marginTop: '50px', alignItems: 'center'}}>
          <Typography variant='h5' >My Hearts</Typography>
          <PlusButton onClick={() => {navigate('/add-heart')}} customStyles={{marginLeft: '10px'}} />
        </Box>
        {/* If hearts[] is empty, then display helper text */}
        {!loading && hearts.length === 0 && (
          <Box sx={{height: '130px', marginTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Typography variant='body2' fontStyle={'italic'} >Add your first heart by clicking the blue +</Typography>
          </Box>
        )}

        {loading ? (
            <Skeleton variant="rectangular" width={'100%'} height={130} sx={{marginTop: '15px'}} />
          ) : (
            <Grid container spacing={2} style={{ width: '100%', marginTop: '10px', marginBottom: '10px'}} direction="row">
            {hearts.map((heart, index) => (
                <Grid item key={index} xs={12} sm={6}>
                  <HeartContainer key={index} id={heart.id} />
                </Grid>
            ))}
            </Grid>
          )}

        <Box sx={{display: 'flex', flexDirection: 'row', marginTop: '30px', alignItems: 'center'}}>
          <Typography variant='h5' >My Groups</Typography>
          <PlusButton onClick={() => {navigate('/add-group')}} customStyles={{marginLeft: '10px'}} />
        </Box>
        {/* If groups[] is empty, then display helper text */}
        {!loading && user.groups.length === 0 && (
          <Box sx={{height: '130px', marginTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Typography variant='body2' fontStyle={'italic'} >Create your first group by clicking the blue +</Typography>
          </Box>
        )}
        {/* TODO: make groups horizontally scrollable */}
        <Grid container spacing={2} style={{ width: '100%', marginTop: '10px', marginBottom: '10px'}} direction="row">
          {loading ? (
              <Skeleton variant="rectangular" width={210} height={118} />
            ) : (
            groups.map((group, index) => (
              // only display the groups that are in user.groups
              user.groups.includes(group.id) && (
                <Grid item key={index} xs={12} sm={6}>
                  <GroupContainer group={group} groupName={group.name} numberMembers={group.members.length} numberHearts={group.hearts.length} colorMode={group.colorMode} groupHearts={groupHearts} hearts={hearts} onClick={() => {navigate(`/manage-group/${group.id}`)}} />
                </Grid>
              )
                
            ))
          )}
        </Grid>

      </TextContainer>
    </AppContainer>
  )
}

export default Home